import { createRoute } from '@tanstack/react-router';
import { rootRoute } from 'routes/rootRoute';

export const errorRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/500',
}).lazy(() => import('pages/shared/errors/Page500/Page500').then((d) => d.Route));
